import Container from "@mui/material/Container";
import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import ComputerIcon from "@mui/icons-material/Computer";
import AppleIcon from "@mui/icons-material/Apple";
import AdbIcon from "@mui/icons-material/Adb";
import CandlestickChartIcon from "@mui/icons-material/CandlestickChart";
import ShopIcon from "@mui/icons-material/Shop";
import { useNavigate, useLocation } from "react-router";
import { OfficialPartner } from "../components/landing/OfficialPartner";
import { Hero } from "../components/landing/Hero";
import { SearchAndCopy } from "../components/landing/SearchAndCopy";
import { CertifiedHistory } from "../components/landing/CertifiedHistory";
import { Results } from "../components/Results";
import { Feedback } from "../components/Feedback";

import "../styles/scss/general.scss";
import { useTranslation } from "react-i18next";
import { useTranslationProvider } from "../providers/TranslationProvider";
import { FooterAll } from "../components/FooterAll";
import PricingPlan from "../components/PricingPlan";
import { Element, scroller } from "react-scroll";
import { useEffect } from "react";
import { Signup } from "./authenticatoin/signup";
import SubmitUserDataForm from "../components/SubmitUserDataForm";

export const Landing = () => {
	const { t } = useTranslation();
	const { language } = useTranslationProvider();

	function redirect(url: string) {
		window.location.href = url;
	}
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		if (location.hash) {
			const targetId = location.hash.replace("#", "");
			scroller.scrollTo(targetId, {
				duration: 500,
				delay: 0,
				smooth: true,
				offset: 0,
			});
		}
	}, [location]);

	return (
		<>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
				}}
			>
				<Hero />

				{/* <SubmitUserDataForm/> */}

				<OfficialPartner />

				<Box
					sx={{
						padding:
							window.innerWidth > 600 ? "12vh 0" : "8vh 16px",
					}}
				>
					<Element name="trader"></Element>
					<Typography
						variant="h3"
						align="center"
						sx={{
							fontFamily: "Work Sans !important",
							fontWeight: "600",
							fontSize: window.innerWidth < 600 ? "32px" : "50px",
						}}
					>
						{t("landing.copysignalsfrom")}{" "}
						<span style={{ color: "#2AD4D4" }}>
							{t("landing.bestTraders")}
						</span>{" "}
					</Typography>
					<Typography
						mt={2}
						variant="h6"
						align="center"
						sx={{
							fontFamily: "Work Sans !important",
							fontWeight: "300",
							fontSize: window.innerWidth < 600 ? "16px" : "18px",
						}}
					>
						{t("landing.startGenerating")}{" "}
						<b>{t("landing.secondIncome")}</b>
					</Typography>

					<Results />
					<Stack
						direction="row"
						justifyContent="center"
						alignItems="center"
						spacing={0}
					></Stack>
				</Box>
				<div id="app"></div>
				<SearchAndCopy />
				<CertifiedHistory />

				{/* <Box
					sx={{
						padding: window.innerWidth > 600 ? "6vh 0" : "6vh 16px",
					}}
				>
					<Typography
						variant="h3"
						align="center"
						sx={{
							fontFamily: "Work Sans !important",
							fontWeight: "600",
							fontSize: window.innerWidth < 600 ? "32px" : "50px",
						}}
					>
						{t("general.aboutus")}
					</Typography>
					<Typography
						mt={2}
						variant="h6"
						align="center"
						sx={{
							fontFamily: "Work Sans !important",
							fontWeight: "300",
							fontSize: window.innerWidth < 600 ? "16px" : "18px",
						}}
					>
						{t("landing.startGenerating")}{" "}
						<b>{t("landing.secondIncome")}</b>
					</Typography>

					 <Feedback /> 
				</Box> */}

				<PricingPlan />
				{/* <Signup isFromLanding /> */}

				<Box
					sx={{
						background: "#232839",
						padding: window.innerWidth > 600 ? "16vh" : "16vh 1vh",
					}}
				>
					<Container>
						<Typography
							variant="h3"
							align="center"
							sx={{
								fontFamily: "Work Sans !important",
								fontWeight: "600",
								fontSize:
									window.innerWidth < 600 ? "32px" : "56px",
							}}
						>
							{t("general.becomeATraderNow")}
						</Typography>
						<Typography
							mt={2}
							variant="h6"
							align="center"
							sx={{
								fontFamily: "Work Sans !important",
								fontWeight: "300",
								fontSize:
									window.innerWidth < 600 ? "16px" : "18px",
							}}
						>
							{t("general.shareStrategies")}
						</Typography>
						<Button
							variant="contained"
							color="secondary"
							startIcon={<CandlestickChartIcon />}
							sx={{
								textTransform: "none",
								margin: "16px auto 8px auto",
								fontWeight: "600",
								borderRadius: "100px",
								display: "flex",
							}}
							onClick={() => {
								redirect("/signup");
							}}
						>
							{t("general.signupAsTrader")}
						</Button>
					</Container>
				</Box>

				<Box
					sx={{
						padding: window.innerWidth > 600 ? "8vh 0" : "2vh 1vh",
					}}
				>
					<Container>
						<Grid container spacing={0}>
							<Grid
								md={4}
								xs={12}
								sx={{
									padding: "20px",
								}}
							>
								<Box className="card bg-green">
									<Box
										sx={{
											background: "#131721",
											width: "72px",
											height: "72px",
											textAlign: "center",
											borderRadius: "100px",
										}}
									>
										<ComputerIcon
											sx={{
												fontSize: "32px",
												marginTop: "20px",
												color: "#fff",
											}}
										></ComputerIcon>
									</Box>
									<div className="titleCard">
										<span className="badge">
											Desktop / VPS
										</span>
										Metatrader4
									</div>
									<div className="textCard">
										{t("landing.ifYouAreATrader")}{" "}
										<b>{t("landing.bestStrategies")}</b>
									</div>
									<Button
										variant="contained"
										color="primary"
										startIcon={<CandlestickChartIcon />}
										sx={{
											textTransform: "none",
											margin: "16px 0 8px 0",
											fontWeight: "600",
											borderRadius: "100px",
										}}
										onClick={() => {
											redirect("/signup");
										}}
									>
										{t("general.becomeATrader")}
									</Button>
								</Box>
							</Grid>

							<Grid
								md={4}
								xs={12}
								sx={{
									padding: "20px",
								}}
							>
								<Box className="card">
									<Box
										sx={{
											background: "#131721",
											width: "72px",
											height: "72px",
											textAlign: "center",
											borderRadius: "100px",
										}}
									>
										<AppleIcon
											sx={{
												fontSize: "32px",
												marginTop: "20px",
												color: "#fff",
											}}
										></AppleIcon>
									</Box>

									<div className="titleCard">
										<span className="badge">
											{t("landing.mobilePhone")}
										</span>
										iOS
									</div>
									<div className="textCard">
										{language == "it" && (
											<>
												Installa l'app di xsee sul tuo
												dispositivo <b>Apple</b>
											</>
										)}
										{language == null ||
											(language == "en" && (
												<>
													Install the xsee app on your{" "}
													<b>Apple</b> device
												</>
											))}
									</div>

									<Button
										variant="contained"
										color="secondary"
										startIcon={<AppleIcon />}
										sx={{
											textTransform: "none",
											margin: "16px 0 8px 0",
											fontWeight: "600",
											borderRadius: "100px",
										}}
										onClick={() => {
											redirect(
												"https://apps.apple.com/it/app/xsee/id6467227843"
											);
										}}
									>
										Download iOS
									</Button>
								</Box>
							</Grid>

							<Grid
								md={4}
								xs={12}
								sx={{
									padding: "20px",
								}}
							>
								<Box className="card">
									<Box
										sx={{
											background: "#131721",
											width: "72px",
											height: "72px",
											textAlign: "center",
											borderRadius: "100px",
										}}
									>
										<AdbIcon
											sx={{
												fontSize: "32px",
												marginTop: "20px",
												color: "#fff",
											}}
										></AdbIcon>
									</Box>
									<div className="titleCard">
										<span className="badge">
											{t("landing.mobilePhone")}
										</span>
										Android
									</div>
									<div className="textCard">
										{language == "it" && (
											<>
												Installa l'app di xsee sul tuo
												dispositivo <b>Android</b>
											</>
										)}
										{language == null ||
											(language == "en" && (
												<>
													Install the xsee app on your{" "}
													<b>Android</b> device
												</>
											))}
									</div>

									<Button
										variant="contained"
										color="secondary"
										startIcon={<ShopIcon />}
										sx={{
											textTransform: "none",
											margin: "16px 0 8px 0",
											fontWeight: "600",
											borderRadius: "100px",
										}}
										onClick={() => {
											redirect(
												"https://play.google.com/store/apps/details?id=com.sinapsa.Xsee&pli=1"
											);
										}}
									>
										Download Android
									</Button>
								</Box>
							</Grid>
						</Grid>
					</Container>
				</Box>

				<FooterAll />
			</Box>
		</>
	);
};
